<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="病种名称">
              <j-input placeholder="请输入病种名称" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="CODE">
              <j-input placeholder="请输入CODE" v-model="queryParam.code"></j-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="关键字">
              <j-input placeholder="请输入关键字" v-model="queryParam.keyword"></j-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
              <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader"
                :action="importExcelUrl" @change="handleImportExcel">
                <a-button type="primary" icon="import" style="margin-left: 8px">导入</a-button>
              </a-upload>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
        :pagination="ipagination" :loading="loading" class="j-table-force-nowrap" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <tempConfigDisease-modal ref="modalForm" @ok="modalFormOk"></tempConfigDisease-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import TempConfigDiseaseModal from './modules/TempConfigDiseaseModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JInput from '@comp/jeecg/JInput.vue'

export default {
  name: "TempConfigDiseaseList",
  mixins: [JeecgListMixin],
  components: {
    JInput,
    TempConfigDiseaseModal
  },
  data() {
    return {
      description: '项目配置-知识库-病种管理页面',
      // 表头
      columns: [
        {
          title: '病种名称',
          align: "center",
          dataIndex: 'name'
        },
        {
          title: 'CODE',
          align: "center",
          dataIndex: 'code'
        },
        {
          title: '关键字',
          align: "center",
          dataIndex: 'keyword'
        },
        {
          title: '描述',
          align: "center",
          ellipsis: true,
          dataIndex: 'description',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list: "/tempconfig/tempConfigDisease/list",
        delete: "/tempconfig/tempConfigDisease/delete",
      },
    }
  },
  computed: {
    importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/tempconfig/tempConfigDisease/importExcel`;
      }
  },
  methods: {

  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>